import { DynamicFormV2Palette } from "@mui/material";

export type FormCartWidgetComponentTokenType = {
  backgroundColor: string;
  hoverBackgroundColor: string;
  iconColor: string;
  border: string;
  badgeBackgroundColor: string;
  badgeTextColor: string;
};

export const assignCartWidgetComponentTokens = (
  formsPalette: DynamicFormV2Palette["forms"],
  mode: "light" | "dark",
  isDull: boolean
) => {
  const isLightMode = mode === "light";

  return {
    backgroundColor: isLightMode ? formsPalette.surface.supershy : formsPalette.surface.moderate,
    hoverBackgroundColor: !isLightMode && isDull ? formsPalette.surface.supershy : formsPalette.surface.quiet,
    iconColor: isLightMode ? (isDull ? formsPalette.text.intense : formsPalette.text.brand) : formsPalette.text.intense,
    border: `1px solid ${formsPalette.border.brand}`,
    badgeBackgroundColor: isLightMode ? formsPalette.surface.moderate : formsPalette.surface.reverse,
    badgeTextColor: isLightMode
      ? isDull
        ? formsPalette.text.intense
        : formsPalette.text.brand
      : isDull
        ? formsPalette.text.reverse
        : formsPalette.text.intense,
  } as FormCartWidgetComponentTokenType;
};
